/** Textes « disponibilites » — le français fait foi. */
export const disponibilites = {
  titre: 'Voitures libres',
  sousTitre: 'Deux dates, la réponse. Le temps de préparation est déjà compté.',
  du: 'Du',
  au: 'Au',
  joursFactures: (jours: number, tampon: number) => `${jours} jour(s) facturés · tampon de préparation ${tampon} min`,
  nbLibres: (n: number) => `${n} voiture(s) libre(s)`,
  rienDeLibre: 'Rien de libre sur cette période',
  periode: (debut: string, fin: string) => `Du ${debut} au ${fin}.`,
  libresTitre: 'Libres — prix calculé pour toute la période',
  thVehicule: 'Véhicule',
  thImmatriculation: 'Immatriculation',
  thCategorie: 'Catégorie',
  thTarifJour: 'Tarif / jour',
  thTotalPeriode: 'Total période',
  saison: (saison: string) => `saison ${saison}`,
  reserver: 'Réserver',
  prisesTitre: 'Prises — et quand elles se libèrent',
  thMotif: 'Motif',
  thLibreAPartir: 'Libre à partir du',
  aucunVehicule: 'Aucun véhicule dans la flotte',
};
